import { render, staticRenderFns } from "./HeaderSetting.vue?vue&type=template&id=dbe66772&"
import script from "./HeaderSetting.vue?vue&type=script&lang=js&"
export * from "./HeaderSetting.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSetting.vue?vue&type=style&index=0&id=dbe66772&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports